import { render, staticRenderFns } from "./LayoutOpen.vue?vue&type=template&id=6ed2ab14&scoped=true"
import script from "./LayoutOpen.vue?vue&type=script&lang=js"
export * from "./LayoutOpen.vue?vue&type=script&lang=js"
import style0 from "./LayoutOpen.vue?vue&type=style&index=0&id=6ed2ab14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed2ab14",
  null
  
)

export default component.exports